import styled from '@emotion/styled';

import MainButton from '@/components/UI/mobile/MainButton';

export const FixListWrapper = styled('div', {
  label: 'fix-front-desk-wrapper',
})`
  height: 100%;
  padding-inline: 6vw;
  display: grid;
  grid-template-rows: auto auto 1fr;
`;

export const AddFixButton = styled(MainButton, { label: 'add-fix-button' })`
  margin-block: 4.5vw;
`;

export const FixItemList = styled('div', { label: 'fix-item-list' })`
  height: 100%;
  overflow-y: auto;

  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
